export default __webpack_public_path__ + "static/media/linkIcon.5bd38fbe.svg";